import { Field, Int, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class AdminStatsDto {
  // The UTC day the row counts, at midnight. Replaced `day` — the day of the month alone, which folded
  // every month in a 30- or 90-day window onto the same bucket (sc-28186). The never-populated `month`
  // and `year` went with it: anything that needs them can read them off this.
  @Field({ nullable: true })
  date?: Date

  @Field(t => Int, { nullable: true })
  entityId?: number

  @Field(t => Int)
  count!: number
}
